module.exports = __webpack_public_path__ + "static/media/top-brand-33.e717ff72.png";